export default __webpack_public_path__ + "static/media/C5.71f89c9a.png";